import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../../baseClasses/BaseComponent';
import Animate from '../../../../components/Animate';
import TaskCompletionStep from './TaskCompletionStep';
import TaskCompletionStepEdit from './TaskCompletionStepEdit';
import AnalyticsLogger from '../../../../helpers/analytics/analyticsLogger';
import dataModel from '../../../../models/DataModel';
import DataSource from '../../../../dao/DataSource/DataSource';
import { completion_criteria_root } from '../../../../dao/CompletionCriteriaDAO';
import { task_complete } from '../../../../dao/TasksDAO';
import { getCompletionStepUserPermissions } from '../../../../helpers/permissions/CompletionStepPermissionsUtil';

import './TaskCompletionSteps.scss';

/*
const taskDescriptor = {
  task: {
    completion_criteria: {
      attachments: {
        additionalFields: ["upload", "photo_longitude", "photo_latitude", "photo_taken_at"],
        conversions: {},
        user: {} 
      } ,
      comments: { user: {additionalFields: ["profile_image"] }},
      event_histories: { activity: {}, activity_sub_type: {}, user_who_performed_action: {} },
      form_fields: {}
    },
    reference_documents: {},
    user_task_assignments: {
      user: { additionalFields: ["profile_image"], 
        companies: {}
      }
    },
    build_owners: { companies: {} },
    inventory_items: {  inventory: {} },
    event_histories: { activity: {}, activity_sub_type: {}, user_who_performed_action: {} }
  }
}
*/

export class TaskCompletionSteps extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      addingNewStep: false,
      expanded: true,
      setOriginalHeight: true,
      task: null,
      initialized: false,
      expandAll: false,
    };
    this.draggableCC = {};
    this.handleSaveCompletionStep = this.handleSaveCompletionStep.bind(this);
  }

  handleRetrieveTask(task, action, acData) {
    this.setState({ task, initialized: !this.state.initialized && action != 'prefetch' });
  }
  
  componentDidMount() {
    const currentRole = this.props.currentUser ? this.props.currentUser.role : null;

    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: dataModel.mobileBridge.isMobile,
    });
    this.taskDataSource = new DataSource('Task', this.props.task, task_complete, this.handleRetrieveTask);
    this.taskDataSource.get();
  }

  componentDidUpdate(prevProps) {
    this.scrollWhileDragging = this.scrollWhileDragging || {};
    if (this.props.task && prevProps.task && this.props.task.id != prevProps.task.id) {
      if (this.taskDataSource) {
        this.taskDataSource.release();
      }
      this.taskDataSource = new DataSource('Task', this.props.task, task_complete, this.handleRetrieveTask);
      this.taskDataSource.get();
    }
  }

  componentWillUnmount() {
    if (this.taskDataSource) {
      this.taskDataSource.release();
      this.taskDataSource = null;
    }
  }

  handleAddStep() {
    this.setState({ addingNewStep: true });
  }

  handleAddStepKeyPress(e) {
    if (e.key == 'Enter') {
      this.handleAddStep();
    }
  }

  handleContract() {
    if (this.state.expanded || this.state.setOriginalHeight) {
      this.setState({ animateContract: true });
    }
  }

  handleExpand() {
    if (!this.state.expanded) {
      this.setState({ expanded: true, animateExpand: true });
    }
  }

  handleFinishAnimation() {
    if (this.state.expanded && this.state.animateContract) {
      this.setState({
        animateContract: false,
        expanded: false,
        setOriginalHeight: false,
      });
    } else {
      this.setState({ animateExpand: false });
    }
  }

  handleFindDragTarget(y) {
    if (!this.draggableContainer) {
      return null;
    }
    const { task } = this.state;
    const containerRect = this.draggableContainer.getBoundingClientRect();
    const normalizeY = y - containerRect.top + 40;
    let firstInList = true;
    for (let i = 0; i < task.completion_criteria.length; i++) {
      if (task.completion_criteria[i]) {
        let id = task.completion_criteria[i].id;
        if (id) {
          if (this.draggableCC[id]) {
            const element = document.getElementById(id);
            if (element) {
              if (
                firstInList &&
                normalizeY < element.offsetTop &&
                normalizeY <= element.offsetTop + element.offsetHeight / 2
              ) {
                this.dragBefore = true;
                return {
                  item: this.draggableCC[id],
                  y: element.offsetTop,
                  x: element.offsetLeft,
                  height: element.offsetHeight,
                  width: element.offsetWidth,
                };
              } else if (
                normalizeY >= element.offsetTop &&
                normalizeY <= element.offsetTop + element.offsetHeight
              ) {
                this.dragBefore = false;
                return {
                  item: this.draggableCC[id],
                  y: element.offsetTop,
                  x: element.offsetLeft,
                  height: element.offsetHeight,
                  width: element.offsetWidth,
                };
              }
              firstInList = false;
            }
          }
        }
      }
    }
  }

  handleCreateDragIndicator() {
    this.lineElement = document.createElement('div');
    this.lineElement.style.width = 'calc(100% - 120px)';
    this.lineElement.style.marginLeft = '40px';
    this.lineElement.style.height = '6px';
    this.lineElement.style.backgroundColor = '#a7a7a7';
    this.lineElement.style.position = 'absolute';
    this.lineElement.style.zIndex = 999;
    this.draggableContainer.appendChild(this.lineElement);
  }

  handlePositionDragIndicator() {
    if (this.dragTarget) {
      let top =
        this.dragTarget.y +
        this.dragTarget.height +
        6; 

      if (this.dragBefore) {
        top = this.dragTarget.y + 4;
      }

      this.lineElement.style.top = top + 'px';
      this.lineElement.style.left = this.dragTarget.x + 'px';
    }
  }

  handleDragging(completionStep, x, y) {
    // Start in one column, and stay in that column
    if (!this.dragX && this.scrollWhileDragging) {
      const rect = this.scrollWhileDragging.getBoundingClientRect();
      this.dragObject = completionStep;
      this.dragX = rect.left;
      this.dragTarget = this.handleFindDragTarget(y);
      this.handleCreateDragIndicator();
      if (this.dragTarget) {
        this.handlePositionDragIndicator();
      }
    } else {
      const newDragTarget = this.handleFindDragTarget(y);
      if (
        (newDragTarget && newDragTarget != this.dragTarget) ||
        this.dragBefore
      ) {
        this.dragTarget = newDragTarget;
        this.handlePositionDragIndicator();
      }
    }
    if (this.dragTarget && this.scrollWhileDragging) {
      const scrollerRect = this.scrollWhileDragging.getBoundingClientRect();
      if (y + 30 + this.dragTarget.height > scrollerRect.bottom) {
        this.scrollWhileDragging.scrollTop +=
          y + 30 + this.dragTarget.height - scrollerRect.bottom;
        this.handlePositionDragIndicator();
      } else if (y < scrollerRect.top) {
        this.scrollWhileDragging.scrollTop -= Math.abs(y - scrollerRect.top);
        this.handlePositionDragIndicator();
      }
    }
  }

  handleDragFinished() {
    this.draggableContainer.removeChild(this.lineElement);
    delete this.dragX;
    delete this.lineElement;
    delete this.dragTarget;
    // this.setState({ })
  }

  sortCCS(ccs) {
    return ccs.sort((t1, t2) => {
      if (t1.order && !t2.order) {
        return 1;
      } else if (!t1.order && t2.order) {
        return -1;
      } else if (t1.order && t2.order) {
        if (t1.order < t2.order) {
          return -1;
        } else if (t1.order > t2.order) {
          return 1;
        } else {
          return 0;
        }
      } else if (t1.id < t2.id) {
        return -1;
      } else if (t1.id > t2.id) {
        return 1;
      } else return 0;
    });
  }
 
  orderCCS(completionSteps, afterCC, insertedCC, task) {
    let orderedCCS = [];
    task.completion_criteria = [];
    let order = 1;
    if (!afterCC) {
      insertedCC.order = order;
      order++;
      orderedCCS.push(insertedCC);
      for (let i = 0; i < completionSteps.length; i++) {
        const copyCS = completionSteps[i];
        if (copyCS.id != insertedCC.id) {
          copyCS.order = order;
          orderedCCS.push(copyCS);
          order++;
        }
      }
    } else {
      for (let i = 0; i < completionSteps.length; i++) {
        const copyCS = completionSteps[i];
        if (copyCS.id != insertedCC.id) {
          copyCS.order = order++;
          orderedCCS.push(copyCS);
          if (copyCS.id == afterCC.id) {
            insertedCC.order = order++;
            orderedCCS.push(insertedCC);
          }
        }
      }
    }
    task.completion_criteria = orderedCCS;
    return orderedCCS;
  }

  handleDropping(completionStep) {
    const { task } = this.state;
    if (this.dragTarget) {
      let afterCC = this.dragBefore ? null : this.dragTarget.item;
      if ((afterCC && afterCC.id != completionStep.id) || !afterCC) {
        if (task && task.completion_criteria) {
          this.sortCCS([...task.completion_criteria]);
          const reorderedCCS = this.orderCCS(
            [...task.completion_criteria],
            afterCC,
            completionStep,
            task
          );
          dataModel.completionCriteriaDAO.reorderCompletionCriteria(task, reorderedCCS, true).then(updatedSteps => {
            task.completion_criteria = updatedSteps;
            this.taskDataSource.get();
          });
        }
        if (this.scrollWhileDragging) {
          this.scrollWhileDragging.scrollTop = 0;
        }
      }
    }
    this.handleDragFinished();
  }

  handleDragCancel() {
    this.handleDragFinished();
  }

  createCompletionStepList() {
    const { editing } = this.props;
    const { addingNewStep, task } = this.state;
    this.completionStepTotalHeight = 0;
    const length = task.completion_criteria
      ? task.completion_criteria.length
      : 0;
    if (length == 0 && !addingNewStep) {
      this.completionStepTotalHeight += 15;
      if (this.state.initialized) {
        return (
          <div className="no-steps-found">{'No Completion Steps found.'}</div>
        );
      }
      else{
        return null;
      }
    } else {
      const { 
        currentCompany,
        currentUser, 
        isBuildOwner, 
        project,
      } = this.props;
      
      if (!currentCompany || !currentUser) {
        return null;
      }
  
      const totalCS = task.completion_criteria.length;
      return task.completion_criteria.map((cc, index) => {
        
        const stepPermissions = getCompletionStepUserPermissions({
          currentCompany,
          currentUser, 
          isBuildOwner, 
          project,
          task, 
          view: currentUser.super_admin ? 'projects' : (this.props.view == 'tasks' ? 'completionStep' : this.props.view),
          completionStep: cc,
          isVendor: currentUser.isVendorUser,
        });
    
        this.completionStepTotalHeight += 62;
        this.draggableCC[cc.id] = cc;

        if (editing && cc && !cc.completed_at && !cc.rejected_at) {
          // Step is not started, so it can still be edited
          return (
            <TaskCompletionStepEdit
              id={cc.id}
              project={this.props.userProject}
              key={'completionStep' + cc.id}
              completionStep={cc}
              handleCancelAddCompletionStep={this.handleCancelAddCompletionStep}
              handleDeleteCompletionStep={this.handleDeleteCompletionStep}
              handleSaveCompletionStep={this.handleSaveCompletionStep}
              handleDragging={this.handleDragging}
              handleDropping={this.handleDropping}
              handleDragCancel={this.handleDragCancel}
              enableDragDrop={!addingNewStep && totalCS > 1}
              newCompletionStep={false}
              dataModel={dataModel}
            />
          );
        } else {
          return (
            <TaskCompletionStep
              id={cc.id}
              editing={editing}
              pmCanEdit={this.props.pmCanEdit}
              project={this.props.userProject}
              projectTemplate={this.props.projectTemplate}
              task={task}
              completionStep={cc}
              key={'completionStep' + cc.id}
              firstInList={index == 0}
              handleDeleteCompletionStep={this.handleDeleteCompletionStep}
              handleDragging={this.handleDragging}
              handleDropping={this.handleDropping}
              handleDragCancel={this.handleDragCancel}
              enableDragDrop={!addingNewStep}
              userStepPermissions={stepPermissions}
              isBuildOwner={this.props.isBuildOwner}
              buildOwnerEditing={this.props.buildOwnerEditing}
              handleUpdate={this.props.handleUpdate}
              expandAll={this.state.expandAll}
            />
          );
        }
      });
    }
  }

  handleCancelAddCompletionStep() {
    this.setState({ addingNewStep: false });
  }

  handleDeleteCompletionStep(completionStep) {
    let stepStartedText = completionStep.completed_at
      ? ' Work has begun on this completion step.'
      : '';
    const message =
      'Are you sure you want to delete ' +
      completionStep.name +
      '?' +
      stepStartedText +
      ' This action cannot be undone.';

    this.props.dataModel.showGlobalModal('SYSTEM_POPUP', {
      width: 320,
      height: 184,
      message: message,
      cancelButtonText: this.textMap.cancel,
      okButtonText: 'YES',
      handleOwnerOk: () => {
        dataModel.completionCriteriaDAO.deleteCompletionCriterion(completionStep, true).then(updatedCompletionStep => {
        });
      },
    });
  }

  getNextInOrder(task) {

    // back fill any nulls first
    let backfillOrder = 1;
    task.completion_criteria && task.completion_criteria.forEach(async (cc) => {
      if (!cc.order) {
        cc.order = backfillOrder++;
        await dataModel.completionCriteriaDAO.updateCompletionCriterion(cc);
      }
      else if (cc.order > backfillOrder) {
        backfillOrder = cc.order + 1;
      }
    });

    let highestOrder = 0;
    task.completion_criteria && task.completion_criteria.forEach((cc) => {
      if (cc.order && cc.order > highestOrder) {
        highestOrder = cc.order;
      }
    });
    return highestOrder ? (highestOrder + 1) : 1;
  }

  // Currently, completion step updates should occur independently of whether the
  // user clicks the 'Save' button on the task edit page
  handleSaveCompletionStep(completionStep) {
    const { task } = this.state;
    if (completionStep.completion_type == 'inspection') {
      this.analyticsLogger.logStepCreate('CompletionStepInspectionAdded');
    }
    else if (completionStep.completion_type == 'form') {
      this.analyticsLogger.logStepCreate('CompletionStepFormAdded');
    }

    if (task) {
      completionStep.task_id = task.id;
      
      if (!completionStep.id) {
        //new step
        completionStep.order = this.getNextInOrder(task);
        dataModel.completionCriteriaDAO.createCompletionCriterion(completionStep, null, { recordDescriptor: completion_criteria_root })
          .then(newStep => {
            if (this.props.handleUpdate) {
              if (!task.completion_criteria) {
                task.completion_criteria = [];
              }
              task.completion_criteria.push(newStep);
              this.props.handleUpdate(task);
            }
            this.setState({ addingNewStep: false });
            this.addStepButton.focus();
          });
      } else {
        //existing step
        dataModel.completionCriteriaDAO.updateCompletionCriterion(completionStep, true, true, null, { recordDescriptor: completion_criteria_root })
          .then(updatedStep => {
          }
          );
      }
    }
  }

  handleSetDragElements(draggableContainer, scrollableContainer) {
    if (draggableContainer) {
      this.draggableContainer = draggableContainer;
    }
    if (scrollableContainer) {
      let parent = scrollableContainer.parentElement;
      while (parent) {
        if (parent.className.indexOf('task-crud-scroller') >= 0) {
          this.scrollWhileDragging = parent;
          break;
        }
        parent = parent.parentElement;
      }
    }
  }

  render() {
    const { editing, userStepPermissions, project } = this.props;
    const { task } = this.state;
    if (!task) {
      return null;
    }

    const {
      addingNewStep,
      animateExpand,
      animateContract,
      expanded,
      setOriginalHeight,
    } = this.state;
    let animator = null;
    let id = 'shared-completion-step-list-' + task.id;

    let completionStepList = null;
    if (expanded || setOriginalHeight) {
      completionStepList = this.createCompletionStepList();
    }
    if (animateExpand) {
      let endVal = this.completionStepTotalHeight
        ? this.completionStepTotalHeight + 68
        : 52;
      let duration = 250;
      animator = (
        <Animate
          component_id={id}
          key="animate_expand"
          property={{ height: { startVal: 52, endVal: endVal } }}
          completionCallback={this.handleFinishAnimation}
          duration={duration}
        />
      );
    } else if (animateContract) {
      let duration = 250;
      animator = (
        <Animate
          component_id={id}
          key="animate_contract"
          property={{ height: { endVal: 52 } }}
          completionCallback={this.handleFinishAnimation}
          duration={duration}
        />
      );
    }

    // Edit/Add Completion Step
    let addStepButton, newCompletionStep;
    if (editing) {
      if (addingNewStep) {
        newCompletionStep = (
          <TaskCompletionStepEdit
            handleCancelAddCompletionStep={this.handleCancelAddCompletionStep}
            handleSaveCompletionStep={this.handleSaveCompletionStep}
            newCompletionStep={true}
            id="new-completion-step"
          />
        );
      } else {
        addStepButton = (
          <div 
            className="add-step-button" 
            ref={el => this.addStepButton = el}
            onClick={this.handleAddStep}
            onKeyUp={this.handleAddStepKeyPress}
            tabIndex={'0'}
          >
            {' '}
          </div>
        );
      }
    }

    return (
      <div
        id={id}
        className="task-docs-container"
      >
        {animator}
        <div className="shared-completion-step-container">
          <div className={'completion-step-header '}>
            <div className={'title '}>
              COMPLETION STEPS
              {addStepButton}
            </div>
          </div>
          <div
            className={'shared-completion-step-list' + (editing ? ' editing': '')}
            style={{ height: 'auto' }}
          >
            <div className={'right-content'} onClick={() => {this.setState({ expandAll: !this.state.expandAll });}}>
              {this.state.expandAll ? <div className="contractor" /> : <div className="expandor" />}
              <div className='right-text'>{this.state.expandAll ? 'Collapse All' : 'Expand All'}</div>
            </div>
            <div className='separator' />
            {newCompletionStep}
            <div
              className={'cc-scrollable'}
              ref={element => {
                this.handleSetDragElements(this.draggableContainer, element);
              }}
            >
              <div
                className="cc-inner-container"
                ref={element => {
                  this.handleSetDragElements(element, this.scrollWhileDragging);
                }}
              >
                {completionStepList}
              </div>
              </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    inProgress: state.main.inProgress,
    permissions: state.new_users ? state.new_users.permissions : null,
    currentUser: state.new_users ? state.new_users.currentUser : null,
    currentCompany: state.new_companies ? state.new_companies.currentCompany : null,
  };
};

export default connect(mapStateToProps)(TaskCompletionSteps);



// WEBPACK FOOTER //
// ./src/components/TaskCRUD/TaskCompletionStepsContainer/TaskCompletionSteps/index.js